// Not actually used to open a modal
// Only created for supporting the 'modalIdType' for the TradeInModalWrapper
export const MODAL_TRADE_IN_WRAPPER = "tradeInWrapper";
